module.exports = __webpack_public_path__ + "img/globe-stand.d9c60ad2.svg";